'use strict';exports.__esModule = true;exports.onmapHostRegex = exports.wwwRegex = undefined;var _isIp = require('./is-ip');var _isIp2 = _interopRequireDefault(_isIp);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var wwwRegex = exports.wwwRegex = /^www\..*/i;
var onmapHostRegex = exports.onmapHostRegex = /^onmap\.co\.il/i;

var getUrlBase = function getUrlBase(request) {var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},_ref$returnLocalhost = _ref.returnLocalhost,returnLocalhost = _ref$returnLocalhost === undefined ? false : _ref$returnLocalhost;
  var host = request.headers.host;
  var localhost = host.indexOf('localhost') === 0;
  var protocol = request.headers['x-forwarded-proto'];

  if (!localhost && !(0, _isIp2.default)(host, true)) {
    var isHttp = protocol === 'http' || !protocol;

    var shouldPrependWWW =
    onmapHostRegex.test(request.headers.host) && !wwwRegex.test(request.headers.host);

    if (isHttp || shouldPrependWWW) {
      var prepend = shouldPrependWWW ? 'www.' : '';
      return 'https://' + prepend + request.headers.host;
    }
  }
  return returnLocalhost ? (protocol || 'http') + '://' + request.headers.host : null;
};exports.default =

getUrlBase;


//////////////////
// WEBPACK FOOTER
// ./src/middleware/utils/get-base-url.js
// module id = 3037
// module chunks = 0